export const TencentDocSocketEvents = {
  OFFICE_TASK_COMPLETED: "EXPORT",
};
export const TencentDocEvents = {
  OFFICE_EXPORT: "OFFICE_EXPORT",
}
/**
 * {
 *  "eventType":"OFFICE_TASK_COMPLETED",
 *  "eventBody": {
 *      "fileId":"31e6138dac2e412b873fec2874785a8b",
 *      "fileName":"测试预览PPT.pptx",
 *      "taskId":"6cc18ec467314d0d8c83bb4dd2c664ed",
 *      "taskType":"OFFICE_EXPORT",
 *      "status":"SUCCESS",
 *      "result":{
 *          "downloadUrl":"https://docs.qa.17u.cn/docstorage/docs-import-export-uat/export/office2pdf/6cc18ec467314d0d8c83bb4dd2c664ed.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AmO91kUxJKQd63QwDMJQ%2F20251028%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20251028T033636Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=fdc6421c17906e612ad344e8234340b2bfb25c7db3624bac0f6351affb117bcc"
 *      },
 *      "deviceId":"8c798fd0fdd4d38d2c4e26ec506d903c"
 *    }
 * }
 */
export const downloadTencentDoc = (eventBody, { message } = {}) => {
  message.closeAll();
  if (
    !eventBody ||
    !eventBody.success
  ) {
    message && message.error('导出失败');
    return;
  }
  // const url = eventBody.result && eventBody.result.downloadUrl;
  // 改为主动拼接链接：http://toca-inner.qa.17usoft.com/file/api/office/task/download-result/{fileId}
  const url = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/export/download/${eventBody.downloadId}`
  if (!url) {
    message && message.error('下载链接不存在');
    return;
  }
  message && message.closeAll();
  // message && message.success('导出成功，正在下载...');
  const link = document.createElement('a');
  link.href = url;
  link.download = eventBody.fileName || 'downloaded_file';
  link.setAttribute('target', '_blank');
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



